import { MenuItem } from '@mui/material';
import React from 'react';
import { CiCircleMinus, CiEdit, CiTrash } from 'react-icons/ci';
import { RiRefreshLine } from 'react-icons/ri';
 

interface RowData {
    contactId: string;
    active: number;
    isBranch: number;
    mobNo?: string;
    loyaltyPoints?: number;
  }
//   interface RowData {
//     mobNo?: string;
//     loyaltyPoints?: number;
// }

interface ActionMenuItemsProps {
  row: RowData;
  tabView: string;
  contactType: string;
  isEditPoints:boolean
  isEdit: boolean;
  isDelete: boolean;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
  handleOpenEditPointDialog: (mobNo?: string, points?: number | null) => void;
  handleActiveDeactive: (row: RowData) => void | Promise<void>; 
  handleResetPoint: (mobNo?: string, points?: number | null) => void;
  isRefreshPoint: boolean;
  handleActiveDeactiveCustomer: (row: RowData) => void | Promise<void>;
}

const ActionMenuItems: React.FC<ActionMenuItemsProps> = ({
  row,
  isEditPoints,
  isEdit,
  tabView,
  isDelete,
  handleEdit,
  handleDelete,
  handleActiveDeactive,
  handleOpenEditPointDialog,
  handleActiveDeactiveCustomer,
  handleResetPoint,
  isRefreshPoint
}) => {
  return row?.active === 0 ? (
    <>
      {isEdit && (
        <MenuItem onClick={() => handleEdit(Number(row.contactId))}>
          <CiEdit className="common__icon" />
          Edit
        </MenuItem>
      )}
       {row?.isBranch === 0 && isEdit && tabView !== 'transport' && (
          <MenuItem onClick={() => handleActiveDeactiveCustomer(row)}>
            <CiCircleMinus className="common__icon" />
            Deactive
          </MenuItem>
        )}
      {isDelete && row.isBranch === 0 && (
        <MenuItem onClick={() => handleDelete(Number(row.contactId))}>
          <CiTrash className="common__icon" />
          Delete
        </MenuItem>
      )}
      {isEditPoints &&  row.isBranch === 0 && (
         <MenuItem onClick={() => handleOpenEditPointDialog(row.mobNo, row?.loyaltyPoints)}>
                     <CiEdit className="common__icon"/>
                     Edit Points
                   </MenuItem>
      )}
         {isRefreshPoint &&  row.isBranch === 0 && (
        <MenuItem onClick={() => handleResetPoint(row.mobNo, row?.loyaltyPoints)}>
                     <RiRefreshLine className="common__icon"/>
                     Reset Loyalty Points
                   </MenuItem>
      )}
    </>
  ) : (
    <>
      {isDelete && row.isBranch === 0 && (
        <MenuItem onClick={() => handleDelete(Number(row.contactId))}>
          <CiTrash className="common__icon" />
          Delete
        </MenuItem>
      )}
      <MenuItem onClick={() => handleActiveDeactive(row)}>
        <CiCircleMinus className="common__icon" />
        Active
      </MenuItem>
    </>
  );
};

export default ActionMenuItems;
